import useFAQaccordion from "marketingWebsite/utils/useFAQaccordion.js"
import useIntercom from "marketingWebsite/utils/useIntercom.js"
import {
    useFeatureTooltips,
    usePlanSwitcher
} from "marketingWebsite/pricing/index.js"

// Aggregate and calls functions that are unique only for marketing pricing site

usePlanSwitcher()
useFeatureTooltips()
useFAQaccordion()
useIntercom()
